<template>
    <span>{{ display_value }}</span>
</template>

<script>
export default {
    name: "BoooleanDisplay",
    props: {
        value: { default: null },
        trueText: { type: String, default: "Yes" },
        falseText: { type: String, default: "No" },
        nullText: { type: String, default: "??" },
    },
    computed: {
        display_value() {
            return {
                true: this.trueText,
                false: this.falseText,
                null: this.nullText,
            }[this.value];
        },
    },
};
</script>

<style scoped></style>
